<template>
    <div class="multipane-resizer"><slot></slot></div>
</template>
<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component';

 @Component({
  name: 'MultipaneResizer'  
})
export default class MultipaneResizer extends Vue {  
}
</script>